import "./VisualArchive.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheHeadshotSeries from "./sections/TheHeadshotSeries";
import ProductionStills from "./sections/ProductionStills";
import FooterArchive from "@/reusable_sections/Footer";
export default function VisualArchivePage() {
  return <div>
      <MainNavigation />
      <TheHeadshotSeries />
      <ProductionStills />
      <FooterArchive />
    </div>;
}